import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle2, Loader2, X, Lock } from "lucide-react";
import { openCal } from "./smooth";

const API = process.env.REACT_APP_BACKEND_URL;
const EMPTY = { name: "", email: "", phone: "" };

export const PlanGate = ({ open, onClose, items }) => {
  const [f, setF] = useState(EMPTY);
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      await axios.post(`${API}/api/leads`, { ...f, city: "", interest: "plano", message: "Pedido de acesso ao plano financeiro" });
      setState("done");
    } catch (err) {
      setState("idle");
      toast.error(err?.response?.status === 422 ? "Verifique os dados preenchidos." : "Não foi possível enviar. Tente novamente.");
    }
  };

  return (
    <div className="fixed inset-0 z-[70] grid place-items-center bg-navy/80 p-4 backdrop-blur-sm" data-testid="plan-gate-overlay" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} data-testid="plan-gate-modal" className="relative max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-[28px] bg-navy-card p-7 text-white ring-1 ring-white/15 sm:p-10">
        <button onClick={onClose} data-testid="plan-gate-close" className="absolute right-5 top-5 rounded-full border border-white/20 p-2 text-slate-300 hover:text-white" aria-label="Fechar">
          <X className="h-4 w-4" />
        </button>

        {state !== "done" ? (
          <>
            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-orange/15 text-orange ring-1 ring-orange/40"><Lock className="h-5 w-5" /></span>
            <h3 className="mt-5 font-display text-2xl font-black sm:text-3xl">Plano financeiro</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-300 sm:text-base">Deixe os seus dados para desbloquear o plano financeiro indicativo (25.000€ a 35.000€). A sua equipa Soluções Ideais entrará em contacto.</p>
            <form onSubmit={submit} data-testid="plan-gate-form" className="mt-6 space-y-5">
              {[
                ["name", "Nome", "O seu nome", "text"],
                ["email", "Email", "nome@email.pt", "email"],
                ["phone", "Telefone", "+351 9XX XXX XXX", "tel"],
              ].map(([k, label, ph, type]) => (
                <label key={k} className="block">
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300">{label}</span>
                  <input data-testid={`plan-gate-${k}-input`} required={k !== "name"} type={type} value={f[k]} onChange={set(k)} placeholder={ph} className="mt-2 w-full border-b border-white/25 bg-transparent py-3 text-lg text-white outline-none transition-[border-color] duration-300 placeholder:text-slate-500 focus:border-orange" />
                </label>
              ))}
              <button disabled={state === "loading"} data-testid="plan-gate-submit" className="flex w-full items-center justify-center gap-3 rounded-full bg-orange py-4 font-display text-base font-black uppercase tracking-wide text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-orange-deep disabled:opacity-70">
                {state === "loading" ? <Loader2 className="h-5 w-5 animate-spin" /> : "Desbloquear o plano"}
              </button>
            </form>
          </>
        ) : (
          <>
            <CheckCircle2 className="h-11 w-11 text-orange" />
            <h3 className="mt-5 font-display text-2xl font-black sm:text-3xl">Plano desbloqueado, {f.name.split(" ")[0]}.</h3>
            <p className="mt-2 text-sm text-slate-300">Investimento indicativo: <strong className="text-white">25.000€ a 35.000€</strong>, incluindo:</p>
            <ul className="mt-4 space-y-2">
              {items.map((t, i) => (
                <li key={t} data-testid={`plan-item-${i}`} className="flex items-center justify-between rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-3">
                  <span className="font-display font-bold">{t}</span>
                  <span className="font-mono text-xs text-orange">0{i + 1}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs leading-relaxed text-slate-400">Valores indicativos. O plano detalhado é apresentado pela equipa Soluções Ideais numa conversa sem compromisso.</p>
            <button onClick={() => { onClose(); openCal(); }} data-testid="plan-gate-contact-cta" className="mt-5 w-full rounded-full bg-white py-3.5 font-bold text-navy transition-[background-color,color] duration-300 hover:bg-orange hover:text-white">
              Agendar conversa para o plano detalhado
            </button>
          </>
        )}
      </div>
    </div>
  );
};
